export default {
  className: 'coupon',
  title: '购物代金券',
  render: (record) => {
    return `${record.name}`
  },
  fields: [
    {
      name: 'name',
      validators: [
        (val) => val ? null : '代金券名称不可为空'
      ]
    },
    {
      name: 'shopType',
      note: '卡券类型'
    },
    {
      name: 'shopAmount',
      note: '使用金额',
      tooltip: '无条件类型，金额为0,，满减需要设置金额'
    },
    {
      name: 'shopQuota',
      note: '抵扣金额',
      validators: [
        // 可以使用多个验证，依次执行，碰到第一个错误时停止验证
        (value) => value && value > 0 ? null : '请正确填写抵扣金额'
      ]
    },
    {
      name: 'total',
      note: '发放数量'
    },
    {
      name: 'surplus',
      note: '剩余数量',
      disabled: true
    }
  ],
  search: [
    'name'
  ],
  action: {
    edit: false,
    delete: {
      type: 'row',
      text: '删除',
      callback: async ({ record, vm, modelName }) => {
        await vm.confirm('警告', '你确定要删除这条记录吗?')
        await vm.$tkParse.put(`/classes/coupon/${record.objectId}`, {
          isDel: true
        })
        vm.$notification['success']({
          message: '操作成功',
          description: '记录已被删除'
        })
        vm.refresh()
      }
    }
  },
  hooks: {
    beforeFetch ({ where }) {
      where.isDel = {
        $ne: true
      }
      where.couponType = 'shopping'
    },
    beforeInsert ({ data }) {
      data.isDel = false
      data.couponType = 'shopping'
      data.surplus = data.total
      if (data.shopType === 'unconditional') {
        data.shopAmount = 0
      }
    }
  }
}
